/** Clinical HP/LP catalogs plus values harvested from EEG presets/config rows. */

export const CLINICAL_HIGH_PASS_HZ = [
  0, 0.01, 0.03, 0.1, 0.16, 0.3, 0.5, 1, 1.6, 3, 5, 10,
] as const;

export const CLINICAL_LOW_PASS_HZ = [
  15, 30, 35, 50, 70, 100, 120, 150, 200, 300, 500,
] as const;

export function mergeFilterHzOptions(
  catalog: readonly number[],
  extra: Array<number | null | undefined> = [],
): number[] {
  const values = new Set<number>();
  for (const hz of catalog) {
    if (Number.isFinite(hz) && hz >= 0) values.add(hz);
  }
  for (const hz of extra) {
    if (typeof hz === "number" && Number.isFinite(hz) && hz >= 0) {
      values.add(hz);
    }
  }
  return [...values].sort((a, b) => a - b);
}

function readFilterHz(settings: Record<string, unknown> | null | undefined, key: string): number | null {
  const value = settings?.[key];
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function collectPresetFilterHz(
  presets: Array<{ config_settings?: Record<string, unknown> | null }> | null | undefined,
): { highPass: number[]; lowPass: number[] } {
  const highPass: number[] = [];
  const lowPass: number[] = [];
  for (const preset of presets ?? []) {
    const high = readFilterHz(preset.config_settings ?? undefined, "high_pass_filter");
    const low = readFilterHz(preset.config_settings ?? undefined, "low_pass_filter");
    if (high != null) highPass.push(high);
    if (low != null) lowPass.push(low);
  }
  return { highPass, lowPass };
}

export function formatFilterHzLabel(kind: "high-pass" | "low-pass", hz: number): string {
  if (kind === "high-pass" && hz === 0) return "DC";
  return Number.isInteger(hz) ? String(hz) : String(hz);
}
